<template>
    <v-row id="settings" class="pt-3">
        <v-col cols="12"><MyBoat></MyBoat></v-col>
        <v-col cols="12"><SystemStatus></SystemStatus></v-col>
        <v-col cols="12"><Control></Control></v-col>
        <v-col cols="12"><Sensors></Sensors></v-col>
    </v-row>
</template>
<script lang="ts">
    //import { alarm, sensor } from "@/store";
    import { defineComponent, onMounted } from "vue";

    export default defineComponent({
        name: "Settings",
        components: {
            MyBoat: () =>
                import(/* webpackChunkName: "components" */ "./components/MyBoat.vue"),
            SystemStatus: () =>
                import(/* webpackChunkName: "components" */ "./components/SystemStatus.vue"),
            Control: () =>
                import(/* webpackChunkName: "components" */ "./components/Control.vue"),
            Sensors: () =>
                import(/* webpackChunkName: "components" */ "./components/SensorList.vue")
        },
        setup() {
            onMounted(() => {
                //sensor.GetData();
            });
        }
    });
</script>
